<div class="container">
  <mat-card>
    <mat-card-content fxFlex fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px">
        
      <div *ngIf="sourceThemes || allCompanies" class="mw-50 w-50" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px">
        <mat-form-field>
          <mat-label>Source Theme</mat-label>
          <mat-select [(ngModel)]="sourceThemeId" (selectionChange)="onSourceThemeIdChange()">
            <mat-option *ngFor="let item of sourceThemes" [value]="item.id">
              {{ item.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        
        <mat-form-field class="m-t-20">
          <mat-label>Destination Company</mat-label>
          <mat-select [(ngModel)]="destinationCompanyId">
            <mat-option *ngFor="let item of allCompanies" [value]="item.id">
              {{ item.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Destination Theme Name</mat-label>
          <input type="text" matInput [(ngModel)]="destinationThemeName">
        </mat-form-field>

        <div class="m-t-20">
          <mat-checkbox [(ngModel)]="allowOverwritingExistingTheme">Allow overwriting existing theme</mat-checkbox>
        </div>

        <button class="w-100 m-t-20" mat-flat-button color="primary" [disabled]="!sourceThemeId || !destinationCompanyId || !destinationThemeName" (click)="copyTheme()">Copy Source Theme</button>
      </div>

      <div *ngIf="this.errorMessage" class="m-t-20" style="color: red;">
        {{ this.errorMessage }}
      </div>
    </mat-card-content>
  </mat-card>
</div>